import { ErrorModal } from "@/components/shared/modal/error-modal";
import { useAppDispatch, useAppSelector } from "@/store";
import { setLTError } from "@/store/common/common.reducer";
import React, { useState } from "react";

export enum TrackModeEnum {
	LADLE_TRACK,
	TUNDISH_TRACK,
}
export const TrackModeContext = React.createContext<any>(null);

export const TrackModeProvider = ({ children }: any) => {
	const appDispatch = useAppDispatch();
	const [trackMode, setTrackMode] = useState<TrackModeEnum | null>(null);
	const error = useAppSelector((state) => state.common.error);
	const setError = (err: string) => appDispatch(setLTError(err));
	return (
		<TrackModeContext.Provider value={{ trackMode, setTrackMode }}>
			{children}
			<ErrorModal error={error} onHide={() => setError("")} />
		</TrackModeContext.Provider>
	);
};
